import { render, staticRenderFns } from "./ProgramOfStudy.vue?vue&type=template&id=3d26320d&scoped=true&"
import script from "./ProgramOfStudy.vue?vue&type=script&lang=js&"
export * from "./ProgramOfStudy.vue?vue&type=script&lang=js&"
import style0 from "./ProgramOfStudy.vue?vue&type=style&index=0&id=3d26320d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d26320d",
  null
  
)

export default component.exports